/** @jsx jsx */
import { css, jsx } from '@emotion/core';

export default function Refresh(): JSX.Element {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      css={css`
        &:disabled {
          color: rgba(0, 0, 0, 0.26);
        }
      `}
    >
      <path
        d="M10.3125 0.804688L10.4062 2.75C9.35156 1.48438 7.75781 0.6875 6 0.6875C5.97656 0.6875 5.97656 0.6875 5.97656 0.6875C3.14062 0.6875 0.773438 2.72656 0.28125 5.42188C0.28125 5.44531 0.28125 5.46875 0.28125 5.49219C0.28125 5.63281 0.398438 5.75 0.5625 5.75H1.71094C1.82812 5.75 1.94531 5.67969 1.96875 5.53906C2.41406 3.73438 4.03125 2.39844 5.97656 2.39844C7.40625 2.39844 8.67188 3.10156 9.39844 4.20312L7.03125 4.08594H7.00781C6.86719 4.08594 6.72656 4.22656 6.72656 4.36719V5.49219C6.72656 5.63281 6.86719 5.77344 7.00781 5.77344H11.7188C11.8594 5.77344 12 5.63281 12 5.49219V0.78125C12 0.640625 11.8594 0.5 11.7188 0.5H10.5938C10.4531 0.523438 10.3125 0.640625 10.3125 0.78125C10.3125 0.804688 10.3125 0.804688 10.3125 0.804688ZM5.97656 10.625C4.54688 10.625 3.30469 9.92188 2.55469 8.82031L4.94531 8.9375H4.96875C5.10938 8.9375 5.25 8.79688 5.25 8.65625V7.53125C5.25 7.39062 5.10938 7.25 4.96875 7.25H0.28125C0.117188 7.25 0 7.39062 0 7.53125V12.2188C0 12.3828 0.117188 12.5 0.28125 12.5H1.38281C1.52344 12.5 1.66406 12.3828 1.66406 12.2188L1.57031 10.2734C2.625 11.5391 4.21875 12.3359 5.97656 12.3359V12.3125C8.8125 12.3125 11.1797 10.2969 11.6953 7.60156C11.6953 7.57812 11.6953 7.55469 11.6953 7.53125C11.6953 7.39062 11.5781 7.25 11.4141 7.25H10.2656C10.125 7.27344 10.0312 7.34375 9.98438 7.48438C9.5625 9.28906 7.92188 10.625 5.97656 10.625Z"
        fill="currentColor"
      />
    </svg>
  );
}
